/**
 * Directive: addressDetail
 */
angular.module('acme.common.directive.addressDetail', [
  'acme.common.service.api'
])
.directive('addressDetail', ['ApiService', function(ApiService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/address/detail/detail.tpl.html',
      scope: {
        model: '=',
        type: '@',
        title: '@',
        contactId: '@',
        organizationId: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.addressDetail = {


          model: {},
          address: '',
          title: 'Address',

          init: function() {
            if ($scope.title) {
              this.title = $scope.title;
            }
            this.getAddress();
            $scope.$on('AddressDetail::Update', this.onAddressDetailUpdate);
            $scope.$on('$destroy', $scope.$watch('model', this.onModelUpdate));
          },

          change: function() {
            $scope.$emit('AddressDetail::Change', {
              type: $scope.type,
              address: this.model,
              contactId: $scope.contactId
            });
          },

          edit: function() {
            $scope.$emit('AddressDetail::Edit', {
              type: $scope.type,
              address: this.model,
              contactId: $scope.contactId
            });
          },

          getAddress: function() {
            // TODO: Enhance to support non-primary contacts for now this is all that is necessary
            if ($scope.type === 'org') {
              ApiService.organizations.addresses.primary({
                organizationId: $scope.organizationId
              }).then(this.success.getAddress, this.error.getAddress);
            }else if ($scope.type === 'contact') {
              ApiService.organizations.contacts.primary({
                organizationId: $scope.organizationId,
                contactId: $scope.contactId
              }).then(this.success.getAddress, this.error.getAddress);
            }
          },

          update: function(address, save) {

            this.address = '';

            if (address) {
              if (address.streetAddress1) {
                this.address += address.streetAddress1;
              }

              if (address.streetAddress2) {
                this.address += ' ' + address.streetAddress2;
              }

              if (address.city) {
                this.address += ', ' + address.city;
              }

              if (address.state) {
                this.address += ', ' + address.state;
              }

              if (address.country) {
                this.address += ' ' + address.country;
              }

              if (address.zipCode) {
                this.address += ' ' + address.zipCode;
              }
            }

            if (save) {
              // TODO: Enhance to support non-primary contacts for now this is all that is necessary
              if ($scope.type === 'org') {
                if (this.model.id) {
                  ApiService.organizations.addresses.update({
                    organizationId: parseInt($scope.organizationId, 10),
                    isPrimary: true,
                    primary: true,
                    address: this.model
                  }).then(this.success.getAddress, this.error.getAddress);
                } else {
                  ApiService.organizations.addresses.create({
                    organizationId: parseInt($scope.organizationId, 10),
                    isPrimary: true,
                    primary: true,
                    address: this.model
                  }).then(this.success.getAddress, this.error.getAddress);
                }
              } else if ($scope.type === 'contact') {
                if (this.model.id) {
                  //this.model.addressId = parseInt(this.model.id, 10);
                  //this.model.id = parseInt($scope.contactId, 10);
                  ApiService.organizations.contacts.update($.extend({
                    organizationId: parseInt($scope.organizationId, 10),
                    isPrimary: true,
                    primary: true,
                    addressId: this.model.addressId
                  }, this.model)).then(this.success.getAddress, this.error.getAddress);
                } else {
                  //this.model.addressId = parseInt(this.model.id, 10);
                  //this.model.id = parseInt($scope.contactId, 10);
                  ApiService.organizations.contacts.create($.extend({
                    organizationId: parseInt($scope.organizationId, 10),
                    isPrimary: true,
                    primary: true,
                    addressId: this.model.addressId
                  }, this.model)).then(this.success.getAddress, this.error.getAddress);
                }
              }
            }
          },

          success: {
            getAddress: function(response) {
              var self = $scope.addressDetail;
              self.model = response.data.payload;
              // This is an address
              if (!self.model.addressId && !self.model.hasOwnProperty('email')) {
                // Make an addressId field to make it easier to pass around
                self.model.addressId = self.model.id;
              }
              self.update(self.model);
            }
          },

          error: {
            getAddress: function(response) {}
          },

          onAddressDetailUpdate: function(e, data) {

            var self = $scope.addressDetail;

            if (data.type === $scope.type &&
                $scope.contactId === data.contactId &&
                data.address.addressId === self.model.addressId) {
              self.model = data.address;
              self.update(self.model, true);
            }else if (data.address.addressId === self.model.addressId) {
              self.model = data.address;
              self.update(self.model, false);
            }

          },

          onModelUpdate: function(n, o) {
            var self = $scope.addressDetail;

            if (n && n.hasOwnProperty('streetAddress1')) {
              self.model.addressId = n.addressId;
              self.model.streetAddress1 = n.streetAddress1;
              self.model.streetAddress2 = n.streetAddress2;
              self.model.city = n.city;
              self.model.state = n.state;
              self.model.country = n.country;
              self.model.zipCode = n.zipCode;
              self.update(self.model);
            }
          }

        };

        $scope.addressDetail.init();

      }]

    };

}]);